import React from 'react';
import { History } from 'history';
import { InputPassword } from '../../components';
import BaseCreate from '../base/base-create.component'; 
import BaseView from '../base/base-view.component';
import Model from './user-model';  //editable..

interface IProps { 
    history: History;
    code: string;
}

interface IState {
    datarow: Model;
    errors: any;
    userId: number;
}

export default class UserAuthResetPassword extends  React.Component<IProps, IState> {
    constructor(props:IProps) {
        super(props);  
        this.state = {
            datarow: Model.defaultValue(),
            errors: null,
            userId: 0,
        }
        this.onChange = this.onChange.bind(this);
    }

    private onError = (data: any) => {
        this.setState({errors: data});
    }
    
    private onSave = async(data: any) => {
        if (data.id) {
            await this.setState({userId: data.id});
            await Model.setUser(data.user?.id, data.user?.name, data.user?.imageUrl, data.jwt);
        }
        this.props.history.push('/');
    }

    private onLoad = async(data: any) => {
        if (data.id) await Model.setUserPersonalinfo(data.personalinfo, data.personalinfoCaption);
    }
    
    private onChange(fieldName: string, value?: string) { 
        const nextState = {
            ...this.state, datarow: {
                ...this.state.datarow, [fieldName]: value,
            }
        }
        this.setState(nextState);
    }

    public componentDidMount(){
        this.setState({datarow: {...Model.defaultValueResetPassword as any, code: this.props.code}});
    }
    
    render() {
        return (
            //editable..  
            <>        
            <BaseCreate history={this.props.history} caption={Model.caption + ' Reset Password'} buttonCaption='Reset Password'
                endPoint={Model.endPointAuth+ '/reset-password'} model={Model} datarow={this.state.datarow} validations={Model.validationResetPassword} onError={this.onError} onSave={this.onSave} buttonOnBottom disableBackButton disableAutoBack>              
                <InputPassword name='password' label='New Password' value={this.state.datarow.password} error={this.state.errors?.password} onChange={this.onChange} />
                <InputPassword name='passwordConfirmation' label='Retype New Password' value={this.state.datarow.passwordConfirmation} error={this.state.errors?.passwordConfirmation} onChange={this.onChange} />
            </BaseCreate>
            
            {this.state.userId > 0 &&
            <BaseView id={this.state.userId} caption='' 
                model={Model} onLoad={this.onLoad}/>
            }      
            </>
        );
    }     
     
}